<template>
  <CBox
    d="flex"
    align="center"
    justify="center"
    bg="#F0F4F8"
    minH="100vh"
    w="100%"
    :py="['16px', '64px']"
    :px="['16px', '120px']"
  >
    <CFlex justify="center" w="100%" h="100%" minHeight="500px" shadow="lg" borderRadius="16px">
      <CBox w="100%" bg="#ffffff" overflow="hidden" borderRadius="16px">
        <CFlex
          align="center"
          :justify="['start', haveMessages ? 'start' : 'center']"
          position="relative"
          :p="['8px', '16px']"
          :borderBottom="haveMessages ? '1px solid #F1F5F9' : 'none'"
        >
          <CFlex direction="column" :align="['start', haveMessages ? 'start' : 'center']">
            <OmtTypography :as="['h2-bold', 'h1-large']"> OMINT • Rede Credenciada </OmtTypography>
            <OmtTypography as="p2" :fontSize="['10px', '12px']" mt="4px">
              Seu assistente para encontrar prestadores
            </OmtTypography>
          </CFlex>

          <CFlex position="absolute" :top="['8px', '16px']" :right="['8px', '16px']">
            <CPopover
              :is-open="voicePopoverOpen"
              placement="bottom-end"
              gutter="10"
              :close-on-blur="false"
              :use-portal="true"
            >
              <CPopoverTrigger>
                <CBox display="inline-block">
                  <OmtButton
                    align="center"
                    justify="center"
                    w="36px"
                    height="36px"
                    mr="8px"
                    bg="#ffffff"
                    borderRadius="12px"
                    border="1px solid #F1F5F9"
                    @click.stop.prevent="toggleVoicePopover"
                  >
                    <OmtIcons name="gear" />
                  </OmtButton>
                </CBox>
              </CPopoverTrigger>

              <CPopoverContent
                z-index="9999"
                bg="#ffffff"
                border="1px solid #F1F5F9"
                border-radius="16px"
                box-shadow="0 4px 16px rgba(0, 0, 0, 0.1)"
                outline="0"
                :_focus="{ boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)', outline: 'none' }"
                :_focus-visible="{ boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)', outline: 'none' }"
                position="relative"
                :w="['290px', '320px']"
              >
                <CPopoverCloseButton
                  bg="#ffffff"
                  mt="8px"
                  :_focus="{ boxShadow: 'none', outline: 'none' }"
                  :_focus-visible="{ boxShadow: 'none', outline: 'none' }"
                  @click="closeVoicePopover"
                />
                <CPopoverBody padding="16px">
                  <CFlex align="center" justify="space-between" mb="12px">
                    <OmtTypography as="h2-bold" m="0">Voz</OmtTypography>
                    <CBox w="24px" h="24px" />
                  </CFlex>

                  <CFlex justify="space-between" w="100%" align="center" mb="12px">
                    <OmtTypography as="p2" color="var(--colors-light-primary-gray2)" m="0">Voz</OmtTypography>
                    <OmtSelect
                      placeholder="Selecione"
                      :initialValue="selectedVoiceURI"
                      @change="onVoiceChange"
                      borderRadius="12px"
                      height="32px"
                      fontSize="10px"
                      width="200px"
                    >
                      <option value="pt-BR">Português</option>
                      <option value="en-US">English</option>
                    </OmtSelect>
                  </CFlex>

                  <CFlex align="center" mb="12px">
                    <OmtButton
                      align="center"
                      justify="center"
                      height="36px"
                      px="16px"
                      mr="8px"
                      bg="#ffffff"
                      borderRadius="12px"
                      border="1px solid #F1F5F9"
                      cursor="pointer"
                      @click="testVoice"
                    >
                      <OmtTypography as="p0" m="0">Testar</OmtTypography>
                    </OmtButton>

                    <OmtButton
                      align="center"
                      justify="center"
                      height="36px"
                      px="16px"
                      bg="#ffffff"
                      borderRadius="12px"
                      border="1px solid #F1F5F9"
                      cursor="pointer"
                      @click="setDefaultVoice"
                    >
                      <OmtTypography as="p0" m="0">Padrão</OmtTypography>
                    </OmtButton>
                  </CFlex>

                  <OmtTypography as="p2" m="0">
                    A qualidade depende das vozes instaladas no seu sistema/navegador.
                  </OmtTypography>
                </CPopoverBody>
              </CPopoverContent>
            </CPopover>

            <OmtButton
              :isDisabled="isLoading"
              align="center"
              justify="center"
              w="36px"
              height="36px"
              bg="#ffffff"
              borderRadius="12px"
              border="1px solid rgba(16, 24, 40, 0.08)"
              cursor="pointer"
              @click="handleReset"
            >
              <OmtIcons name="arrow-rotate-left" />
            </OmtButton>
          </CFlex>
        </CFlex>

        <CBox
          v-if="messages.length > 0 || isLoading"
          ref="messagesContainer"
          overflow="auto"
          p="16px"
          bg="#FAFCFB"
          :h="['320px', '420px']"
        >
          <CGrid templateColumns="1fr" gap="12px">
            <CBox
              v-for="m in messages"
              :key="m.id"
              :justifySelf="m.from === 'user' ? 'end' : 'start'"
              :maxW="['92%', '760px']"
              :textAlign="m.from === 'user' ? 'right' : 'left'"
            >
              <PreviewFile
                v-if="m.attachment"
                :attachment="m.attachment"
                :bg="m.from === 'user' ? '#E6F0FF' : '#ffffff'"
                :maxW="['92%', '760px']"
              />

              <CBox
                v-else
                :bg="m.from === 'user' ? '#1d4ed8' : '#ffffff'"
                borderRadius="16px"
                :border="m.from === 'user' ? '0' : '1px solid rgba(16, 24, 40, 0.08)'"
                px="16px"
                py="12px"
              >
                <OmtTypography :color="m.from === 'user' ? 'white' : '#111827'" as="p1" m="0" whiteSpace="pre-wrap">{{
                  m.text
                }}</OmtTypography>
              </CBox>
              <OmtTypography v-if="m.from === 'user'" as="p2" mt="4px">{{ m.time }}</OmtTypography>
            </CBox>

            <CBox v-if="isLoading" justifySelf="start" :maxW="['92%', '760px']" textAlign="left">
              <CBox
                bg="#F1F5F9"
                color="#111827"
                borderRadius="16px"
                border="1px solid rgba(16, 24, 40, 0.08)"
                px="16px"
                py="12px"
                role="status"
                aria-live="polite"
              >
                <OmtTypography as="p1" m="0">
                  Aguarde por favor
                  <span class="loading-dots" aria-hidden="true">
                    <span class="loading-dot loading-dot--1"></span>
                    <span class="loading-dot loading-dot--2"></span>
                    <span class="loading-dot loading-dot--3"></span>
                  </span>
                </OmtTypography>
              </CBox>
            </CBox>
          </CGrid>
        </CBox>

        <CBox p="16px" :borderTop="haveMessages ? '1px solid #F1F5F9' : 'none'">
          <PreviewFile v-if="selectedFile" wrap mb="12px" :file="selectedFile" removable @remove="removeSelectedFile" />
          <CFlex
            :h="['48px', '72px']"
            :border="['1px solid rgba(16, 24, 40, 0.08)', 'none']"
            :align="['center', 'end']"
            borderRadius="16px"
          >
            <OmtTextarea
              ref="textarea"
              :mr="['4px', '16px']"
              resize="none"
              :height="['34px', '72px']"
              minH="34px"
              padding="4px"
              borderRadius="16px"
              fontSize="12px"
              :border="['none', '1px solid rgba(16, 24, 40, 0.08)']"
              :placeholder="
                isMobile
                  ? 'Ex: Preciso de um cardiologista'
                  : 'Ex.: Sou associado 0123456789 e preciso de um cardiologista'
              "
              :initialValue="observation"
              @change="handleChange"
            />

            <CFlex align="end">
              <OmtButton
                mr="8px"
                align="center"
                justify="center"
                w="36px"
                height="36px"
                bg="#ffffff"
                borderRadius="12px"
                :border="['none', '1px solid rgba(16, 24, 40, 0.08)']"
                cursor="pointer"
                @click="handleAttachClick"
                :title="selectedFile ? selectedFile.name : 'Anexar arquivo'"
              >
                <OmtIcons name="paperclip" />
              </OmtButton>

              <input ref="fileInput" type="file" style="display: none" @change="handleFileSelected" />

              <OmtButton
                v-if="!isRecording"
                align="center"
                d="flex"
                mr="8px"
                justify="center"
                w="36px"
                height="36px"
                bg="#ffffff"
                borderRadius="12px"
                :border="['none', '1px solid rgba(16, 24, 40, 0.08)']"
                cursor="pointer"
                @click="startRecording"
              >
                <OmtIcons name="microphone" />
              </OmtButton>

              <OmtButton
                v-if="isRecording"
                align="center"
                d="flex"
                mr="8px"
                justify="center"
                w="36px"
                height="36px"
                bg="#ffffff"
                borderRadius="12px"
                :border="['none', '1px solid rgba(16, 24, 40, 0.08)']"
                cursor="pointer"
                @click="stopRecording"
                title="Parar gravação"
              >
                <OmtIcons name="xmark" />
              </OmtButton>
            </CFlex>

            <OmtButton
              :display="['none', 'block']"
              bg="#1d4ed8"
              color="#ffffff"
              w="100px"
              height="34px"
              borderRadius="12px"
              fontWeight="700"
              @click="handleSend"
              :isDisabled="isLoading"
            >
              Enviar
            </OmtButton>
            <OmtButton
              :display="['flex', 'none']"
              :isDisabled="isLoading"
              align="center"
              justify="center"
              w="36px"
              height="36px"
              bg="#ffffff"
              borderRadius="12px"
              :border="['none', '1px solid rgba(16, 24, 40, 0.08)']"
              cursor="pointer"
              @click="handleSend"
            >
              <OmtIcons name="paper-plane-top" />
            </OmtButton>
          </CFlex>

          <CBox
            v-if="this.viewSuggestion"
            mt="12px"
            :p="haveMessages ? '16px' : '0'"
            borderRadius="16px"
            :border="haveMessages ? '1px solid #F1F5F9' : 'none'"
          >
            <CFlex align="center" :justify="haveMessages ? 'space-between' : 'center'">
              <OmtTypography as="p0" m="0">Sugestões</OmtTypography>
              <CFlex
                v-if="haveMessages"
                align="center"
                justify="center"
                w="36px"
                h="36px"
                bg="#ffffff"
                borderRadius="12px"
                border="1px solid rgba(16, 24, 40, 0.08)"
                cursor="pointer"
                @click="handleSuggestion"
              >
                <OmtIcons name="xmark" />
              </CFlex>
            </CFlex>
            <CBox mt="12px">
              <CGrid
                :templateColumns="
                  haveMessages ? (isMobile ? '1fr' : 'repeat(2, 1fr)') : isMobile ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)'
                "
                gap="16px"
              >
                <CBox
                  v-for="(suggestion, idx) in haveMessages ? suggestions.slice(0, 3) : suggestions"
                  :key="idx"
                  as="button"
                  type="button"
                  textAlign="left"
                  borderRadius="16px"
                  border="1px solid rgba(16, 24, 40, 0.08)"
                  bg="#ffffff"
                  p="12px"
                  w="100%"
                  @click="applySuggestion(suggestion.text)"
                >
                  <OmtTypography as="h2-bold" m="0">{{ suggestion.title }}</OmtTypography>
                  <OmtTypography as="p2" mt="4px" m="0">{{ suggestion.description }}</OmtTypography>
                </CBox>
              </CGrid>
            </CBox>
          </CBox>
        </CBox>
      </CBox>
    </CFlex>
  </CBox>
</template>

<script>
import {
  CBox,
  CFlex,
  CGrid,
  CPopover,
  CPopoverTrigger,
  CPopoverContent,
  CPopoverBody,
  CPopoverCloseButton
} from "@chakra-ui/vue";
import { isMobile } from "@/utils/utils";
import { BuscarPrestadorViaChat } from "@/api/redeCredenciada";
import PreviewFile from "./components/preview-file.vue";

export default {
  name: "Chat",
  components: {
    CBox,
    CFlex,
    CGrid,
    CPopover,
    CPopoverTrigger,
    CPopoverContent,
    CPopoverBody,
    CPopoverCloseButton,
    PreviewFile
  },
  data() {
    return {
      observation: "",
      messages: [],
      isLoading: false,
      selectedFile: null,
      viewSuggestion: true,
      voicePopoverOpen: false,
      voices: [],
      selectedVoiceURI: "",
      defaultVoiceURI: "pt-BR",
      isRecording: false,
      recorder: null,
      stream: null,
      chunks: [],
      mimeType: "",
      audioBlob: null,
      audioUrl: null,
      recordingSeconds: 0,
      recordingTimer: null,
      speechRecognition: null,
      suggestions: [
        {
          title: "Especialidade",
          description: "Quero buscar por especialidade.",
          text: "Quero buscar por especialidade."
        },
        {
          title: "Procedimento",
          description: "Quero buscar por procedimento",
          text: "Quero buscar por procedimento"
        },
        {
          title: "Laboratório",
          description: "Quero buscar um laboratório para exames",
          text: "Quero buscar um laboratório para exames"
        },
        {
          title: "Hospital",
          description: "Quero buscar um hospital na minha rede",
          text: "Quero buscar um hospital na minha rede"
        },
        {
          title: "Por nome",
          description: "Quero buscar um prestador pelo nome",
          text: "Quero buscar um prestador pelo nome"
        },
        {
          title: "Pedido médico (imagem)",
          description: "Quero um pedido médico em anexo",
          text: "Quero solicitar um pedido médico com imagem"
        }
      ]
    };
  },
  computed: {
    isMobile() {
      return isMobile();
    },
    haveMessages() {
      return this.messages.length > 0;
    },
    availableVoices() {
      return (this.voices || []).map(v => ({
        voiceURI: v.voiceURI,
        label: `${v.name}${v.lang ? ` (${v.lang})` : ""}`
      }));
    }
  },
  watch: {
    messages() {
      this.scrollToBottom();
    },
    isLoading() {
      this.scrollToBottom();
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
    this.$nextTick(() => {
      const textarea = this.$refs.textarea?.$el;
      if (textarea) {
        textarea.addEventListener("keydown", this.handleTextareaKeydown);
      }
    });
    this.scrollToBottom();
  },
  beforeDestroy() {
    const textarea = this.$refs.textarea?.$el;
    if (textarea) {
      textarea.removeEventListener("keydown", this.handleTextareaKeydown);
    }
    this.clearAttachmentMessagePreviewUrls();
  },
  methods: {
    toggleVoicePopover() {
      this.voicePopoverOpen = !this.voicePopoverOpen;
    },
    closeVoicePopover() {
      this.voicePopoverOpen = false;
    },
    onVoiceChange(e) {
      this.selectedVoiceURI = e;
    },
    getTestText(lang) {
      const map = {
        "pt-BR": "Olá! Este é um teste de voz em português.",
        "en-US": "Hello! This is a voice test in English."
      };
      return map[lang];
    },
    testVoice() {
      if (!window.speechSynthesis) return;

      window.speechSynthesis.cancel();

      const voicesNative = window.speechSynthesis.getVoices() || [];

      let voice = null;
      let lang = this.selectedVoiceURI;

      if (lang === "pt-BR") {
        voice = voicesNative.find(v => v.lang && v.lang.toLowerCase().startsWith("pt"));
      } else if (lang === "en-US") {
        voice = voicesNative.find(v => v.lang && v.lang.toLowerCase().startsWith("en"));
      }

      const utter = new SpeechSynthesisUtterance(this.getTestText(lang));
      utter.lang = lang;

      if (voice) {
        utter.voice = voice;
      }

      utter.onerror = e => console.error("TTS error:", e);
      window.speechSynthesis.speak(utter);
    },
    setDefaultVoice() {
      this.selectedVoiceURI = this.defaultVoiceURI;
    },
    getNowTime() {
      const d = new Date();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      return `${hh}:${mm}`;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const ref = this.$refs.messagesContainer;
        const el = ref && (ref.$el || ref);
        if (!el) return;
        el.scrollTop = el.scrollHeight;
      });
    },
    clearAttachmentMessagePreviewUrls() {
      (this.messages || []).forEach(m => {
        const url = m?.attachment?.previewUrl;
        if (url) URL.revokeObjectURL(url);
      });
    },
    getFileExtensionFromName(name) {
      const n = (name || "").trim();
      const idx = n.lastIndexOf(".");
      if (idx === -1) return "ARQ";
      const ext = n.slice(idx + 1).trim();
      return (ext || "ARQ").slice(0, 6).toUpperCase();
    },
    setSelectedFile(file) {
      this.selectedFile = file || null;
    },
    removeSelectedFile() {
      this.setSelectedFile(null);
      const input = this.$refs.fileInput;
      const el = input && (input.$el || input);
      if (el) el.value = null;
    },
    pushBotMessage(text) {
      this.messages.push({
        id: `m_${Date.now()}_bot`,
        from: "system",
        text,
        time: this.getNowTime()
      });
    },
    async fileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async handleSend() {
      if (!this.observation && !this.selectedFile) return;

      const sendingFile = this.selectedFile;
      const now = Date.now();
      const time = this.getNowTime();
      const messageText = this.observation;

      this.isLoading = true;

      if (sendingFile) {
        const file = sendingFile;
        const ext = this.getFileExtensionFromName(file.name).toLowerCase();
        const isImage =
          (!!file.type && file.type.startsWith("image/")) ||
          ["png", "jpg", "jpeg", "webp", "gif", "bmp", "heic", "heif"].includes(ext);
        const previewUrl = isImage ? URL.createObjectURL(file) : "";
        this.messages.push({
          id: `m_${now}_file`,
          from: "user",
          text: "",
          time,
          attachment: {
            name: file.name,
            type: file.type || "",
            extension: this.getFileExtensionFromName(file.name),
            previewUrl
          }
        });
      }

      if (messageText) {
        this.messages.push({
          id: `m_${now}`,
          from: "user",
          text: messageText,
          time
        });
      }

      this.observation = "";
      this.scrollToBottom();

      try {
        let imageDataUrl = null;
        if (sendingFile) {
          imageDataUrl = await this.fileToDataUrl(sendingFile);
        }

        const response = await BuscarPrestadorViaChat({
          message: messageText || "",
          imageDataUrl
        });

        this.isLoading = false;

        const replyRaw =
          (response && (response.reply || response.message || response.Data?.reply || response.data?.reply)) ||
          (typeof response === "string" ? response : null);

        const reply = replyRaw || "Não foi possível processar sua mensagem no momento. Tente novamente em instantes.";

        this.pushBotMessage(reply);
        this.scrollToBottom();
      } catch (error) {
        this.isLoading = false;
        this.pushBotMessage("Ocorreu um erro ao enviar sua mensagem. Verifique sua conexão e tente novamente.");
        this.scrollToBottom();
      } finally {
        this.removeSelectedFile();
      }
    },
    handleChange(text) {
      this.observation = text;
    },
    handleTextareaKeydown(event) {
      if (event.key === "Enter") {
        if (event.ctrlKey) {
          return;
        } else {
          event.preventDefault();
          this.handleSend();
        }
      }
    },
    applySuggestion(text) {
      this.observation = text;
    },
    handleAttachClick() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },
    handleFileSelected(event) {
      const f = event && event.target && event.target.files ? event.target.files[0] : null;
      if (f) this.setSelectedFile(f);

      if (event && event.target) event.target.value = null;
    },
    handleReset() {
      this.clearAttachmentMessagePreviewUrls();
      this.messages = [];
      this.observation = "";
      this.removeSelectedFile();
    },
    handleSuggestion() {
      this.viewSuggestion = false;
    },
    startRecording() {
      try {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
          alert("Seu navegador não suporta reconhecimento de voz.");
          return;
        }

        if (this.isRecording) return;

        this.speechRecognition = new SpeechRecognition();
        this.speechRecognition.lang = "pt-BR";
        this.speechRecognition.interimResults = true;
        this.speechRecognition.maxAlternatives = 1;
        this.isRecording = true;

        let finalTranscript = this.observation || "";

        this.speechRecognition.onresult = event => {
          let interimTranscript = "";
          for (let i = event.resultIndex; i < event.results.length; i++) {
            const transcript = event.results[i][0].transcript;
            if (event.results[i].isFinal) {
              finalTranscript += (finalTranscript ? " " : "") + transcript;
            } else {
              interimTranscript += transcript;
            }
          }
          this.observation = finalTranscript + (interimTranscript ? ` ${interimTranscript}` : "");
        };

        this.speechRecognition.onerror = () => {
          this.isRecording = false;
        };

        this.speechRecognition.onend = () => {
          this.isRecording = false;
          this.speechRecognition = null;
        };

        this.speechRecognition.start();
      } catch (err) {
        console.error(err);
        alert(err.message || "Falha ao iniciar reconhecimento de voz.");
        this.isRecording = false;
      }
    },
    stopRecording() {
      try {
        if (!this.isRecording) return;
        if (this.speechRecognition) {
          this.speechRecognition.stop();
          return;
        }
        this.isRecording = false;
      } catch (e) {
        console.error(e);
        this.isRecording = false;
      }
    },
    startTimer() {
      this.stopTimer();
      this.recordingSeconds = 0;
      this.recordingTimer = setInterval(() => {
        this.recordingSeconds += 1;
      }, 1000);
    },
    stopTimer() {
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }
    },
    cleanupStream() {
      try {
        if (this.stream && this.stream.getTracks) {
          this.stream.getTracks().forEach(t => t.stop());
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.stream = null;
      }
    },
    logRecordedAudio() {
      //TODO: implementar envio do áudio para o backend ou processamento necessário.
      return;
    }
  }
};
</script>

<style scoped>
.loading-dots {
  display: inline-flex;
  align-items: flex-end;
  gap: 4px;
  margin-left: 16px;
  vertical-align: middle;
}

.loading-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  animation: loading-dot-bounce 900ms ease-in-out infinite;
}

.loading-dot--1 {
  background: #9ca3af;
  animation-delay: 0ms;
}

.loading-dot--2 {
  background: #6b7280;
  animation-delay: 120ms;
}

.loading-dot--3 {
  background: #4b5563;
  animation-delay: 240ms;
}

@keyframes loading-dot-bounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-5px);
    opacity: 1;
  }
}
</style>
